import { render, staticRenderFns } from "./pim-callback.vue?vue&type=template&id=161bd2d4&scoped=true"
import script from "./pim-callback.vue?vue&type=script&lang=js"
export * from "./pim-callback.vue?vue&type=script&lang=js"
import style0 from "./pim-callback.vue?vue&type=style&index=0&id=161bd2d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161bd2d4",
  null
  
)

export default component.exports